import { Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { KeyboardListNavigationDirective } from './keyboard-list-navigation.directive';
import { KeyboardPipeSource, KeyboardUtils } from './keyboard.utils';

/**
 * Eine Direktive, die Navigieren mithilfe der Pfeiltasten und Tabtaste ermöglicht.
 * Erfordert KeyboardListDirective.
 *
 * Selector "commonKeyboardArrows" is deprecated and should be removed in future versions.
 */
@Directive({
    selector: '[commonKeyboardListNavArrow], [commonKeyboardArrows]'
})
export class KeyboardListNavigationArrowDirective<T> extends KeyboardListNavigationDirective<T> {
    getNavigationOperator(): (source$: KeyboardPipeSource<T>) => Observable<number> {
        return KeyboardUtils.arrowKeyToDirectionOperator;
    }

    getNavigationKeysFilterPredicate(): (event: KeyboardEvent) => boolean {
        return event => KeyboardUtils.isKeyboardAction(event, 'up') || KeyboardUtils.isKeyboardAction(event, 'down');
    }
}
